/**
 * Download a file from a URL and trigger browser download
 * @param url - The URL to download from
 * @param filename - The filename to save as
 */
export async function downloadFileFromUrl(
  url: string,
  filename: string
): Promise<void> {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(
      `Download failed: ${response.status} ${response.statusText}`
    )
  }

  const blob = await response.blob()
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  window.URL.revokeObjectURL(blobUrl)
}
